import {buildGroupPayload} from './filters';

/**
 * Inline "Filter Criteria" bar on each dashboard report/chart. Ad-hoc only for v1:
 * nothing here is persisted, it just overrides the chart's Default Filter
 * (chart->filter_id) for the current view. Reuses the existing filter-builder
 * condition-row markup/handlers from filters.js (.criteria-field/.criteria-condition
 * cascading, .add-criteria/.remove-criteria) - this file only wires the
 * open/seed/apply/clear behavior specific to the dashboard.
 */
$(document).ready(function (e) {
    if (!$('.charts').length) {
        return;
    }

    let $body = $('body');

    function addBlankRow($bar) {
        let table_id = $bar.attr('data-table-id');

        $.ajax({
            type: 'GET',
            url: `/filter/${table_id}/group`,
            data: {
                showGroupQuery: 0
            },
            success: (res) => {
                $bar.find('.chart-filter-groups').html(res);
                $bar.find('.remove-criteria-group').addClass('d-none');
                $('.selectpicker').selectpicker({
                    noneSelectedText: translation.nothing_selected
                });
            }
        });
    }

    $body.on('click', '.toggle-chart-filter-bar', function (e) {
        e.preventDefault();
        let chart_id = $(this).data('id'),
            $bar = $(this).parents('.chart').find('.chart-filter-bar[data-chart-id="' + chart_id + '"]');

        $bar.toggleClass('d-none');

        if (!$bar.hasClass('d-none') && !$bar.find('.criteria-group').length) {
            let table_id = $bar.attr('data-table-id'),
                filter_id = $bar.attr('data-default-filter-id');

            if (filter_id) {
                $.ajax({
                    type: 'GET',
                    url: `/filter/${table_id}/${filter_id}/criteria`,
                    success: (res) => {
                        $bar.find('.chart-filter-groups').html(res);
                        $bar.find('.remove-criteria-group').addClass('d-none');
                        $('.selectpicker').selectpicker({
                            noneSelectedText: translation.nothing_selected
                        });
                    }
                });
            } else {
                addBlankRow($bar);
            }
        }
    });

    $body.on('click', '.apply-chart-filter', function (e) {
        e.preventDefault();
        let $bar = $(this).parents('.chart-filter-bar'),
            chart_id = $bar.attr('data-chart-id'),
            $groups = $bar.find('.criteria-group'),
            {group_payload, error} = buildGroupPayload($groups);

        if (error) {
            return;
        }

        let non_empty_groups = group_payload.filter((group) => group.payload.length);

        window.redrawDashboardChart(chart_id, non_empty_groups.length ? non_empty_groups : false);
    });

    $body.on('click', '.clear-chart-filter', function (e) {
        e.preventDefault();
        let $bar = $(this).parents('.chart-filter-bar'),
            chart_id = $bar.attr('data-chart-id');

        addBlankRow($bar);

        window.redrawDashboardChart(chart_id, false);
    });
});
